import {connect} from 'react-redux';
import {reduxForm, formValueSelector} from "redux-form";
import {resetCurrentForm,
  setReturnsFilter,
  fetchCustomerReturnsByFilter,
  createCustomerReturn,
  editCustomerReturn,
  dispatchEditReturn,
  fetchDispatchReturns,
  clearCurrentReturn,
  fetchCustomers,
  changeRMAStatus,
  uploadRMA,
} from "../../actions/rma_actions";
import Rma from "../../components/RMA/rma";
import { setValue } from '../../actions/sales_actions';
import { setDefaultDays, setDefaultOfForm } from '../../actions/purchaseOrders_actions';

const rma = reduxForm({
    form: 'rma',
})(Rma);

const selector = formValueSelector('rma');

function mapStateToProps(state) {
    return {
        // customers: state.rma.customers,
        customerOptions: state.rma.customers.map(customer => ({
          label: customer.Name,
          value: customer.Customer_id,
        })),
        customerReturns: state.rma.customerReturns,
        pages: state.rma.pages,
        count: state.rma.count,
        dispatchReturns: state.rma.dispatchReturns,
        isLoading: state.rma.isLoading,
        error: state.rma.error,
        customerReturnError: state.rma.customerReturnError,
        dispatchReturnError: state.rma.dispatchReturnError,
        isCreating: state.rma.isCreating,
        createCustomerReturnError: state.rma.createCustomerReturnError,
        created: state.rma.created,
        editCustomerReturnError: state.rma.editCustomerReturnError,
        editDispatchReturnError: state.rma.editDispatchReturnError,
        isEditing: state.rma.isEditing,
        returnsFilter: state.rma.returnsFilter,
    };
}

export default connect(mapStateToProps, {
    fetchCustomerReturnsByFilter, 
    createCustomerReturn, 
    editCustomerReturn, 
    dispatchEditReturn, 
    fetchDispatchReturns,
    setReturnsFilter,
    setValue,
    setDefaultDays,
    setDefaultOfForm,
    resetCurrentForm,
    clearCurrentReturn,
    fetchCustomers,
    changeRMAStatus,
    uploadRMA,
})(Rma);


// WEBPACK FOOTER //
// ./master/jsx/containers/RMA/rma.jsx